import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Img from '../Home/Images/IMG4.jpg';
import Image from 'react-bootstrap/Image';
import RCI from '../Assets/RCI.jpeg';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';

function About() {
    return (
        <Container fluid>
            <Row>
                <Col lg={12}>
                    <Image src={Img} style={{ width: "-webkit-fill-available" }} />
                </Col>
                <Col style={{ paddingTop: "30px" }} lg={12}>
                    <h4>ABOUT ME</h4>
                    <Image src={RCI} height="100px"/>
                    <p>Hello, I' m RCI licensed clinical psychologist with over four years of experience in the field of
                        mental health. I also focus on a holistic approach with clients to maintain wellbeing and to
                        promote strong therapeutic alliance. </p>
                    <p>I'm skilled in comprehensive psychometric assessments
                        and formulating therapy based on the needs of the client.</p>
                    <p>I strive to create a safe and
                        comfortable environment for my client.</p>
                </Col>
                <Col lg={12} style={{ paddingTop: "30px" }}>
                    <h4>MY APPROACH</h4>
                    <p>I am committed to an eclectic approach and mostly focus on third wave therapies and also
                        skilled in various therapeutic modalities.</p>

                    <p><b>What can you expect to take away from us?</b></p>
                    <p>A strong sense of self exploration, empowerment and acceptance. To attain realistic ways of
                        thinking and normalizing the issues faced by them in all the phases of their life</p>

                    <p><b>Who do I specialize in serving?</b></p>
                    <p>I have worked with individuals of diverse age groups and I'm interested in serving people from
                        various walks. I have intense interest towards Children and adolescents with emotional and
                        behavioral conditions along with parental intervention</p>

                    <p><b>Finally, what difference do you want to make in the lives of people that approach you?</b></p>
                    <p>I would also promote positive ways of self- awareness and support my clients to be resilient
                        and oriented towards the present. As a therapist I always believe and focus on client centered
                        approaches that will allow them to follow in their life.</p>
                </Col>
                <Col lg={12} style={{ paddingTop: "30px" }}>
                    <h4>PROFESSIONAL EXPERIENCE</h4>
                    <p>As a Consultant I have gained experience in the following :screening/interviewing/
                        assessments, skills training and development, interpersonal relationships, work stress and
                        management and therapeutic interventions.</p>

                    <p>I have engaged myself as therapist, academic coordinator, a facilitator and speaker at
                        workshops, provided psychological assessments and therapeutic interventions. This experience
                        has also confined various training programs for students and the general population on a wide
                        variety of topics. I have assisted clients with issues from various walks of life. I am committed
                        and sincere professional who genuinely finds joy and reward in assisting my clients to be
                        resilient</p>
                </Col>
                <Col lg={12}>
                    <h4>EDUCATIONAL QUALIFICATION</h4>
                    <ul>
                        <li>M.Phil Clinical Psychology - National Institute for Empowerment - Chennai</li>
                        <li>M.Sc Applied Psychology - Bharathiar University - Coimbatore</li>
                        <li>B.Sc Psychology - Avinashilingam University for Home Science and Higher Education for Women Coimbatore</li>                       
                        <li>Master Diploma in Medical Psychology (MDMP) Krishna Academy of Psychological Medicine - Coimbatore</li>
                    </ul>
                </Col>
                <Col lg={12} style={{ paddingTop: "30px" }}>
                    <Contact />
                </Col>
            </Row>
            <Row style={{ paddingTop: "30px", paddingBottom: "30px" }}><Col lg={12}><Footer /></Col></Row>
        </Container>
    );
}

export default About;